import React, { useCallback } from 'react';
import ToggleSwitch from '../../../../core/components/ToggleSwitch';

type SubscribeToggleRendererProps = {
    item: { [key: string]: any };
    colKey: string;
};

export function createSubscribeToggleRenderer(
    onToggle: (item: any, colKey: string, newVal: boolean) => Promise<boolean>,
): (props: SubscribeToggleRendererProps) => JSX.Element {
    const SubscribeToggleRenderer = ({ item, colKey }: SubscribeToggleRendererProps): JSX.Element => {
        const checked = item[colKey] === 'ON';

        const handleChange = useCallback(
            async (val: boolean): Promise<void> => {
                await onToggle(item, colKey, val);
            },
            [item, colKey],
        );

        return (
            <span
                className="subscribe-toggle-cell"
                onClick={(e): void => e.stopPropagation()}
            >
                <ToggleSwitch
                    checked={checked}
                    onChange={handleChange}
                    labelOn="ON"
                    labelOff="OFF"
                />
            </span>
        );
    };

    SubscribeToggleRenderer.displayName = 'SubscribeToggleRenderer';
    return SubscribeToggleRenderer;
}
